import { render, staticRenderFns } from "./CostCenterAttribution.vue?vue&type=template&id=81cd39b4"
import script from "./CostCenterAttribution.vue?vue&type=script&lang=js"
export * from "./CostCenterAttribution.vue?vue&type=script&lang=js"
import style0 from "./CostCenterAttribution.vue?vue&type=style&index=0&id=81cd39b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports